<template>
  <div class="networkSearchItem networkSearchItem--user">
    <span
      class="networkSearchItemImage"
      :style="{
        backgroundImage: `url('${getAvatarLink(
          data.avatar,
          getDefaultAvatar($role.USER),
        )}')`,
      }"
    ></span>
    <div class="networkSearchItemText">
      <h3 class="networkSearchItemTitle">
        {{ data.name }}
        <div
          v-if="data.classification"
          class="networkSearchItem__status chip-user"
          :style="`background-color:${chipColor(data.classification)}}`"
        >
          {{ chipText(data.classification) }}
        </div>
      </h3>
      <h5 class="networkSearchItemDesc">
        {{ data.address }}
      </h5>
      <div class="groupBtn">
        <button class="networkSearchItemButton" @click="viewProfile">
          프로필 보기
        </button>
        <button
          class="networkSearchItemButton blue"
          @click="showApply"
          v-if="user.roleName != 'ROLE_ADMIN'"
        >
          신청/자문하기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import matchingColorMixins from "@/mixins/matching-color-mixins";

export default {
  name: "ItemSearchUser",
  props: ["data"],
  mixins: [matchingColorMixins],
  data() {
    return {
      user: this.$store.state.auth.user,
    };
  },
  methods: {
    viewProfile() {
      this.$emit("viewProfile");
    },
    showApply() {
      this.$emit("showApply");
    },
  },
};
</script>
